import { z } from "zod";
import { Id, IsoDateTime } from "./common.ts";

/** Privacy / social visibility mode chosen at check-in ("tonight mode"). */
export const PrivacyMode = z.enum(["invisible", "discreet", "social"]);
export type PrivacyMode = z.infer<typeof PrivacyMode>;

export const StaffRole = z.enum(["owner", "manager", "staff"]);
export type StaffRole = z.infer<typeof StaffRole>;

/**
 * Customer identity. `lineUserId` is established ONLY via server-side LINE token
 * verification — never trusted from the client. Display fields are presentation-only.
 */
export const CustomerProfile = z.object({
  id: Id,
  lineUserId: z.string().optional(),
  displayName: z.string().min(1),
  avatarUrl: z.url().optional(),
  ageVerified: z.boolean().default(false),
  createdAt: IsoDateTime,
});
export type CustomerProfile = z.infer<typeof CustomerProfile>;

/** A customer's presence at a table during a session, with chosen privacy mode. */
export const CheckIn = z.object({
  id: Id,
  sessionId: Id,
  tableId: Id,
  customerId: Id,
  privacyMode: PrivacyMode,
  nickname: z.string().min(1).optional(),
  checkedInAt: IsoDateTime,
  checkedOutAt: IsoDateTime.optional(),
});
export type CheckIn = z.infer<typeof CheckIn>;

export const StaffUser = z.object({
  id: Id,
  venueId: Id,
  displayName: z.string().min(1),
  role: StaffRole,
  email: z.email().optional(),
  isActive: z.boolean().default(true),
  createdAt: IsoDateTime,
});
export type StaffUser = z.infer<typeof StaffUser>;
